import { Component, OnInit, Output, Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { NgIf } from '@angular/common';
import { NgClickOutsideDirective } from 'ng-click-outside2';

@Component({
    selector: 'app-item-success',
    templateUrl: './item-success.component.html',
    styleUrls: ['./item-success.component.scss'],
    standalone: true,
    imports: [NgClickOutsideDirective, NgIf]
})
export class ItemSuccessComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Input() sucessMsg: string;
  /** Heading copy. Defaults to the edit-flow wording so existing callers are
   *  unchanged; the Create flow passes "Item Created". */
  @Input() title = 'Successful Update';
  /** Optional secondary line under the message: a non-blocking advisory about the
   *  write that just succeeded (the HUBX-8429 category notice is the first one).
   *  Defaults to empty and then renders nothing, so every existing caller is
   *  untouched — the same additive pattern as `title`. */
  @Input() note = '';
  /** Optional line for what a multi-row save did NOT write (HUBX-8478), under the success
   *  line. Empty by default, so every other caller is untouched - the pattern of `note`. */
  @Input() failedMsg = '';
  /** Optional second button beside Continue (HUBX-8498): the listing's save result offers
   *  "Show Unsaved Items" when a row was not saved. Empty by default, so every other caller
   *  is untouched - the pattern of `note`. The caller decides what clicking it does,
   *  closing included. */
  @Input() actionLabel = '';
  @Output() action = new EventEmitter<void>();
  /** The listing's save result (HUBX-8498) marks its success line with the row's "Saved."
   *  check, so it reads like the failure line under it. Off by default: the other callers'
   *  confirmations are unchanged. */
  @Input() successIcon = false;
  constructor() { }

  ngOnInit() {}

}
